const React = require('react');

module.exports = ({title, value}) => (
  <div>
    <span className="dB f12 fw4 lh17 c8E8EA1">{title}</span>
    <span className="dB mt7 f12 fw7 lh17 break">{value}</span>
  </div>
);
